// extracted by mini-css-extract-plugin
export default {"container":"Links_container__9-x4J","containerForLinks":"Links_containerForLinks__2SDca"};